export type InternalCapabilities = {
  ok: boolean;
  internalAdminEnabled: boolean;
};

type ParsedResponse<T> = {
  data: T | null;
  text: string;
};

async function parseResponse<T>(response: Response): Promise<ParsedResponse<T>> {
  const text = await response.text();
  if (!text) {
    return { data: null, text: "" };
  }
  try {
    return { data: JSON.parse(text) as T, text };
  } catch {
    return { data: null, text };
  }
}

export async function fetchInternalCapabilities(): Promise<InternalCapabilities> {
  const response = await fetch("/internal/capabilities", {
    headers: { accept: "application/json" },
  });

  const { data: payload, text } = await parseResponse<InternalCapabilities & { error?: string }>(response);

  if (!response.ok) {
    const message = payload?.error ?? text;
    throw new Error(message || `Failed to load internal capabilities (status ${response.status})`);
  }

  if (!payload) {
    throw new Error("Unexpected response while loading internal capabilities.");
  }

  return payload;
}
